import React from "react";

function TeamMember() {
  return (
    <main>

      {/* ===================== HERO ===================== */}
      <section className="position-relative pt-sm-8 pt-lg-9 overflow-hidden">

        <div className="position-absolute end-0 top-0">
          <img src="assets/images/elements/grad-shape/blur-decoration-2.svg" className="opacity-1 blur-8 h-300px rotate-335" alt="Grad shape" />
        </div>
        <div className="position-absolute start-0 top-0">
          <img src="assets/images/elements/grad-shape/blur-decoration-2.svg" className="opacity-2 blur-9 h-300px rotate-335" alt="Grad shape" />
        </div>
        <div className="position-absolute top-0 start-0">
          <img src="assets/images/elements/bg-pattern.svg" style={{ opacity: '0.05' }} alt="bg pattern" />
        </div>

        <div className="container position-relative">
          <div className="row">
            <div className="col-md-7 mx-auto text-center">
              <h1 className="mb-4">Meet our experts</h1>
              <p className="mb-0">Our dedicated team is passionate about delivering exceptional results that exceed your expectations.</p>
            </div>
          </div>
        </div>
      </section>

      {/* ===================== TEAM GRID ===================== */}
      <section className="pt-0">
        <div className="container">
          {/* Inline style ensures all image wrappers are the same height across all cards */}
          <style>{`
            .team-card-wrapper { height: 340px; overflow: hidden; }
            .team-card-wrapper img { width: 100%; height: 100%; object-fit: cover; object-position: top center; }
          `}</style>
          <div className="row g-4 g-sm-5 justify-content-center">

            {/* Dev Bhuva */}
            <div className="col-sm-6 col-md-4 col-lg-4">
              <div className="card card-img-scale card-content-hover shadow rounded-top-pill overflow-hidden">
                <div className="card-img-scale-wrapper team-card-wrapper">
                  <div className="hover-content h-100">
                    <ul className="list-group list-group-borderless position-absolute bottom-0 end-0 me-3 mb-3">
                      <li className="list-group-item pb-0"><a className="btn btn-sm btn-round bg-instagram-gradient" href="https://www.instagram.com/arixautomation/" target="_blank" rel="noreferrer"><i className="bi bi-instagram"></i></a></li>
                      <li className="list-group-item pb-0"><a className="btn btn-sm btn-round bg-linkedin" href="https://www.linkedin.com/company/arixautomation/posts/?feedView=all" target="_blank" rel="noreferrer"><i className="bi bi-linkedin"></i></a></li>
                    </ul>
                  </div>
                  <img src="assets/images/team/3by4/dev.png" className="card-img-top" alt="Dev Bhuva" />
                </div>
                <div className="card-body text-center px-0">
                  <h6 className="mb-0">Dev Bhuva</h6>
                  <small>Founder</small>
                </div>
              </div>
            </div>

            {/* Brik Patel */}
            <div className="col-sm-6 col-md-4 col-lg-4">
              <div className="card card-img-scale card-content-hover shadow rounded-top-pill overflow-hidden">
                <div className="card-img-scale-wrapper team-card-wrapper">
                  <div className="hover-content h-100">
                    <ul className="list-group list-group-borderless position-absolute bottom-0 end-0 me-3 mb-3">
                      <li className="list-group-item pb-0"><a className="btn btn-sm btn-round bg-facebook" href="https://www.facebook.com/profile.php?id=61584318581650" target="_blank" rel="noreferrer"><i className="bi bi-facebook"></i></a></li>
                      <li className="list-group-item pb-0"><a className="btn btn-sm btn-round bg-instagram-gradient" href="https://www.instagram.com/arixautomation/" target="_blank" rel="noreferrer"><i className="bi bi-instagram"></i></a></li>
                      <li className="list-group-item pb-0"><a className="btn btn-sm btn-round bg-linkedin" href="https://www.linkedin.com/company/arixautomation/posts/?feedView=all" target="_blank" rel="noreferrer"><i className="bi bi-linkedin"></i></a></li>
                    </ul>
                  </div>
                  <img src="assets/images/team/3by4/brikal.png" className="card-img-top" alt="Brik Patel" />
                </div>
                <div className="card-body text-center px-0">
                  <h6 className="mb-0">Brik Patel</h6>
                  <small>Co-Founder</small>
                </div>
              </div>
            </div>

            {/* Dhruvi Patel */}
            <div className="col-sm-6 col-md-4 col-lg-4">
              <div className="card card-img-scale card-content-hover shadow rounded-top-pill overflow-hidden">
                <div className="card-img-scale-wrapper team-card-wrapper">
                  <div className="hover-content h-100">
                    <ul className="list-group list-group-borderless position-absolute bottom-0 end-0 me-3 mb-3">
                      <li className="list-group-item pb-0"><a className="btn btn-sm btn-round bg-instagram-gradient" href="https://www.instagram.com/arixautomation/" target="_blank" rel="noreferrer"><i className="bi bi-instagram"></i></a></li>
                      <li className="list-group-item pb-0"><a className="btn btn-sm btn-round bg-twitter-x" href="#"><i className="bi bi-twitter-x"></i></a></li>
                      <li className="list-group-item pb-0"><a className="btn btn-sm btn-round bg-facebook" href="https://www.facebook.com/profile.php?id=61584318581650" target="_blank" rel="noreferrer"><i className="bi bi-facebook"></i></a></li>
                    </ul>
                  </div>
                  <img src="assets/images/team/3by4/02.jpg" className="card-img-top" alt="Dhruvi Patel" />
                </div>
                <div className="card-body text-center px-0">
                  <h6 className="mb-0">Dhruvi Patel</h6>
                  <small>Content Specialist</small>
                </div>
              </div>
            </div>

            {/* Dharmesh Rupapara */}
            <div className="col-sm-6 col-md-4 col-lg-4">
              <div className="card card-img-scale card-content-hover shadow rounded-top-pill overflow-hidden">
                <div className="card-img-scale-wrapper team-card-wrapper">
                  <div className="hover-content h-100">
                    <ul className="list-group list-group-borderless position-absolute bottom-0 end-0 me-3 mb-3">
                      <li className="list-group-item pb-0"><a className="btn btn-sm btn-round bg-facebook" href="https://www.facebook.com/profile.php?id=61584318581650" target="_blank" rel="noreferrer"><i className="bi bi-facebook"></i></a></li>
                      <li className="list-group-item pb-0"><a className="btn btn-sm btn-round bg-linkedin" href="https://www.linkedin.com/company/arixautomation/posts/?feedView=all" target="_blank" rel="noreferrer"><i className="bi bi-linkedin"></i></a></li>
                    </ul>
                  </div>
                  <img src="assets/images/team/3by4/dharmesh.png" className="card-img-top" alt="Dharmesh Rupapara" />
                </div>
                <div className="card-body text-center px-0">
                  <h6 className="mb-0">Dharmesh Rupapara</h6>
                  <small>Creative Director</small>
                </div>
              </div>
            </div>

            {/* Ishan Ghadiya */}
            <div className="col-sm-6 col-md-4 col-lg-4">
              <div className="card card-img-scale card-content-hover shadow rounded-top-pill overflow-hidden">
                <div className="card-img-scale-wrapper team-card-wrapper">
                  <div className="hover-content h-100">
                    <ul className="list-group list-group-borderless position-absolute bottom-0 end-0 me-3 mb-3">
                      <li className="list-group-item pb-0"><a className="btn btn-sm btn-round bg-instagram-gradient" href="https://www.instagram.com/arixautomation/" target="_blank" rel="noreferrer"><i className="bi bi-instagram"></i></a></li>
                      <li className="list-group-item pb-0"><a className="btn btn-sm btn-round bg-linkedin" href="https://www.linkedin.com/company/arixautomation/posts/?feedView=all" target="_blank" rel="noreferrer"><i className="bi bi-linkedin"></i></a></li>
                      <li className="list-group-item pb-0"><a className="btn btn-sm btn-round bg-twitter-x" href="#"><i className="bi bi-twitter-x"></i></a></li>
                    </ul>
                  </div>
                  <img src="assets/images/team/3by4/ishan.png" className="card-img-top" alt="Ishan Ghadiya" />
                </div>
                <div className="card-body text-center px-0">
                  <h6 className="mb-0">Ishan Ghadiya</h6>
                  <small>Marketing Strategist</small>
                </div>
              </div>
            </div>

            {/* Aliksha Patel */}
            <div className="col-sm-6 col-md-4 col-lg-4">
              <div className="card card-img-scale card-content-hover shadow rounded-top-pill overflow-hidden">
                <div className="card-img-scale-wrapper team-card-wrapper">
                  <div className="hover-content h-100">
                    <ul className="list-group list-group-borderless position-absolute bottom-0 end-0 me-3 mb-3">
                      <li className="list-group-item pb-0"><a className="btn btn-sm btn-round bg-instagram-gradient" href="https://www.instagram.com/arixautomation/" target="_blank" rel="noreferrer"><i className="bi bi-instagram"></i></a></li>
                      <li className="list-group-item pb-0"><a className="btn btn-sm btn-round bg-twitter-x" href="#"><i className="bi bi-twitter-x"></i></a></li>
                    </ul>
                  </div>
                  <img src="assets/images/team/3by4/08.png" className="card-img-top" alt="Aliksha Patel" />
                </div>
                <div className="card-body text-center px-0">
                  <h6 className="mb-0">Aliksha Patel</h6>
                  <small>Lead Developer</small>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ===================== ACHIEVEMENTS ===================== */}
      <section className="pt-0">
        <div className="container">
          <div className="row g-4 g-sm-5">

            <div className="col-lg-5">
              <h2 className="mb-3">Our lifetime achievements</h2>
              <p className="mb-0">Join our team, Creative Agency Specializing in: Video Production, Web Design, Branding, Brand Strategy.</p>

              <div className="row mt-4 mt-lg-6">
                <div className="col-sm-5 mb-3 mb-sm-0">
                  <div className="border-2 border-start border-purple border-opacity-50 ps-3">
                    <div className="d-flex mb-1">
                      <h3 className="purecounter mb-0" data-purecounter-start="0" data-purecounter-end="12" data-purecounter-delay="300">0</h3>
                      <span className="h3 text-primary mb-0">+</span>
                    </div>
                    <p className="mb-0">Total employees</p>
                  </div>
                </div>
                <div className="col-sm-5">
                  <div className="border-2 border-start border-purple border-opacity-50 ps-3">
                    <div className="d-flex mb-1">
                      <h3 className="purecounter mb-0" data-purecounter-start="0" data-purecounter-end="7" data-purecounter-delay="300">0</h3>
                      <span className="h3 text-primary mb-0">+</span>
                    </div>
                    <p className="mb-0">Total awards</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-7 col-xl-6 ms-auto">
              <div className="card card-body overflow-hidden p-0">
                <img src="assets/images/team/video-bg.jpg" className="card-img" alt="team video bg" />
                <div className="bg-overlay bg-dark opacity-2"></div>
                <div className="position-absolute end-0 bottom-0 m-3 z-index-2">
                  <a href="https://www.youtube.com/embed/tXHviS-4ygo" className="btn btn-sm btn-white" data-glightbox="" data-gallery="course-video">
                    <i className="bi bi-youtube text-danger me-1"></i> Watch our story
                  </a>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ===================== CTA ===================== */}
      <section className="bg-secondary-grad position-relative rounded-3 overflow-hidden py-6 py-sm-7">
        <div className="position-absolute end-0 top-0 rotate-13 mt-n5 me-n6 d-none d-sm-block">
          <img src="assets/images/elements/geo-grad-pattern.svg" className="h-600px opacity-3" alt="bg pattern" />
        </div>
        <div className="position-absolute start-0 top-0 rotate-343 mt-n3 ms-n5 d-none d-xl-block">
          <img src="assets/images/elements/grad-shape/10.png" className="h-500px" alt="bg pattern" />
        </div>

        <div className="container">
          <div className="row g-4 align-items-center position-relative">
            <div className="col-xl-6">
              <h2>Partner with our <span className="text-primary-grad">creative</span> team</h2>
              <p className="mb-0">Discover the difference a dedicated, creative, and strategic team can make for your business.</p>
            </div>
            <div className="col-xl-6 text-xl-end">
              <a href="/contact" className="btn btn-dark mb-0">Schedule a consultation</a>
            </div>
          </div>
        </div>
      </section>

    </main>
  );
}

export default TeamMember;
